import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58b83072"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "userinfo__avatar" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "userinfo__nickname" }
const _hoisted_4 = { class: "userinfo__company-name" }
const _hoisted_5 = { style: {"max-width":"214px"} }

import { useUserStore } from '@/store/user'
import { storeToRefs } from 'pinia'
import Icon from '@teams/common/components/icon'
import { ref, h, ComponentPublicInstance } from 'vue'
import { NPopover, NEllipsis } from 'naive-ui'
import Account from '@teams/common/components/multiAccount'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const userStore = useUserStore()
const { currentAccount } = storeToRefs(userStore)
const accountVisible = ref(false)
const userinfoRef = ref<HTMLElement>()
const accountPanelRef = ref<ComponentPublicInstance | null>(null)

const setAccountVisible = (value: boolean) => {
  accountVisible.value = value
}
const CopyIcon = () => {
  const icon = h(Icon, { name: 'copy', size: 12 })
  return icon
}
const CheckIcon = () => {
  const icon = h(Icon, { name: 'check', size: 12, fill: 'none' })
  return icon
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NPopover), {
    trigger: "click",
    "show-arrow": false,
    placement: "bottom",
    style: {"padding":"0","border-radius":"12px","background-color":"var(--background-01)","color":"var(--text-01)","margin-top":"-5px"},
    "on-update-show": setAccountVisible
  }, {
    trigger: _withCtx(() => [
      _createElementVNode("div", {
        class: "userinfo",
        ref_key: "userinfoRef",
        ref: userinfoRef,
        id: "account"
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_unref(currentAccount)?.avatar_url)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(currentAccount)?.avatar_url,
                alt: ""
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(NEllipsis), { style: {"max-width":"220px"} }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(currentAccount)?.nickname), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", {
              class: _normalizeClass(["userinfo__nickname__account-btn-icon", 
                accountVisible.value &&
                `userinfo__nickname__account-btn-icon_rotate90`
              ])
            }, [
              _createVNode(_unref(Icon), {
                name: "rectangle",
                size: 11
              })
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(NEllipsis), {
              style: {"max-width":"228px"},
              tooltip: { placement: 'bottom' }
            }, {
              tooltip: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(currentAccount)?.company_name), 1)
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(currentAccount)?.company_name) + " ", 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 512)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Account), {
        ref_key: "accountPanelRef",
        ref: accountPanelRef,
        "copy-icon": CopyIcon,
        "check-icon": CheckIcon
      }, null, 512)
    ]),
    _: 1
  }))
}
}

})